<template>
	<v-card color="contained">
		<v-card-text>
			<img :src="qrCode" style="height: 256px; width: auto" />
		</v-card-text>
	</v-card>
</template>

<script setup lang="ts">
import { ref } from "vue";
const qrCode = ref("https://assets.livereader.com/asset/3RYLXJ3vmIa7X8Dr.png");
</script>
